export function makeid(N)
{
    /* Started from: https://stackoverflow.com/a/19964557 */
    var firstchars = "abcdefghjkmnpqrstuvwxyz", allchars = "abcdefghjkmnpqrstuvwxyz23456789";
    let val = firstchars.charAt(Math.floor(Math.random()*firstchars.length)) + [...Array(N-1).keys()].map(n => allchars.charAt(Math.floor(Math.random()*allchars.length))).join('')
    return val;
}

export const truncStr = (str, n) => str.length > n ? str.slice(0, n-1) : str

export function getCookieValue(a) {
    var b = document.cookie.match('(^|;)\\s*' + a + '\\s*=\\s*([^;]+)');
    return b ? b.pop() : '';
}

export function humanFileSize(size) {
    /* From https://stackoverflow.com/a/20732091/6587564 */
    var i = size == 0 ? 0 : Math.floor(Math.log(size) / Math.log(1024));
    return +((size / Math.pow(1024, i)).toFixed(2)) * 1 + ' ' + ['B', 'kB', 'MB', 'GB', 'TB'][i];
}

export function styleToString(style)
{
    return Object.keys(style).reduce((acc, key) => (
        acc + key.split(/(?=[A-Z])/).join('-').toLowerCase() + ':' + style[key] + ';'
    ), '');
}

export function styleStringToObject(style)
{
    if ( ! style ) return {}
    return style.split(';').filter(x => x.trim().length > 0).map(cur => cur.split(':')).reduce((acc, val) => {
	let [key, value] = val;
	key = key.replace(/-./g, css => css.toUpperCase()[1])
	acc[key] = value;
	return acc;
    }, {});
}

export function capitalize(string)
{
    return string.charAt(0).toUpperCase() + string.slice(1);
}

function componentToHex(c)
{
    var hex = c.toString(16);
    return hex.length == 1 ? "0" + hex : hex;
}

export function rgbToHex(r, g, b, a)
{
    return "#" + componentToHex(r) + componentToHex(g) + componentToHex(b);
}

export function rgbaToHex({r, g, b, a})
{
    return '#' + componentToHex(r) + componentToHex(g) + componentToHex(b) + componentToHex(Math.floor(a*255))
}

export function hexToRgb(hex)
{
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? {
	r: parseInt(result[1], 16),
	g: parseInt(result[2], 16),
	b: parseInt(result[3], 16)
    } : null;
}

/* From https://stackoverflow.com/a/175787/6587564 */
export function isNumeric(str)
{
    if (typeof str != "string") return false // we only process strings!
    return !isNaN(str) && // use type coercion to parse the _entirety_
			  // of the string (`parseFloat` alone does
			  // not do this)...
    !isNaN(parseFloat(str)) // ...and ensure strings of whitespace fail
}

export function fixDataFields(typemap, fields)
{
    return fields.map(field => ({...field, type: typemap[field.name]}))
}

export function findDataField(fields, fieldName)
{
    const field = fields.find(field => field.name === fieldName)
    if ( field !== undefined && field !== null ) return field
    else return {}
}

export function validateEmail(email)
{
    return String(email)
	.toLowerCase()
	.match(
	    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
	);
}
